export default {
  methods: {
    getAverageFormattedTime(total) {
      let seconds = Math.floor((total / 1000) % 60);
      let minutes = Math.floor((total / (1000 * 60)) % 60);
      let hours = Math.floor((total / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      let strToReturn = "";
      if (hours === "00") {
        strToReturn = minutes + ":" + seconds;
      } else {
        strToReturn = hours + ":" + minutes + ":" + seconds;
      }
      return strToReturn;
    },
    getFormattedTime(total) {
      if (total < 10000) {
        return "00:00";
      }
      let minutes = Math.floor((total / (1000 * 60)) % 60);
      let hours = Math.floor(total / (1000 * 60 * 60));
      let days = Math.floor(hours / 24); // Calculate the number of days
      hours %= 24; // Adjust the hours to be within 0-23 range

      let strToReturn = "";

      if (days > 0) {
        strToReturn += days + (days === 1 ? " day, " : " days, ");
      }

      if (hours > 0) {
        strToReturn += hours + (hours === 1 ? " hour, " : " hours, ");
      }

      if (minutes > 0) {
        strToReturn += minutes + (minutes === 1 ? " minute" : " minutes");
      }

      return strToReturn;
    }
  }
};
